import { config, api, siteKey } from './config'
import { initializeApp } from 'firebase/app'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'
import { getStorage, connectStorageEmulator } from 'firebase/storage'
import {
  initializeAppCheck,
  ReCaptchaV3Provider,
  getToken
} from 'firebase/app-check'
import {
  getFirestore,
  connectFirestoreEmulator,
  doc,
  collection,
  collectionGroup,
  getDoc,
  getDocs,
  query,
  where,
  orderBy,
  limit,
  addDoc,
  setDoc,
  updateDoc,
  deleteDoc,
  onSnapshot,
  runTransaction as firestoreRunTransaction,
  writeBatch,
  increment,
  deleteField,
  arrayUnion,
  arrayRemove,
  startAt,
  startAfter,
  endAt,
  endBefore,
  serverTimestamp
} from 'firebase/firestore'
import firebase from 'firebase/compat/app'

// ---------- 環境判定 ----------
const isLocal =
  location.hostname === 'localhost' || location.hostname === '127.0.0.1'

// FirebaseUI のために compat が必要なら残す
firebase.initializeApp(config)

// v9 App
const app = initializeApp(config)

let appCheck = null

async function initAppCheck() {
  if (!isLocal) {
    appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(siteKey),
      isTokenAutoRefreshEnabled: true
    })

    try {
      // 2) 初回取得
      await getToken(appCheck, false)
      console.log('App Check (V3) Success')
    } catch (err) {
      console.error('App Check Failed', err)
    }
  }
}

// ---------- Storage ----------
const storage = getStorage(app)
if (process.env.NODE_ENV === 'local') {
  connectStorageEmulator(storage, 'localhost', 9199)
}

// ---------- Auth ----------
const auth = getAuth(app)

if (process.env.NODE_ENV === 'local') {
  connectAuthEmulator(auth, 'http://localhost', 9099)
}

// ---------- Functions ----------
const functions = getFunctions(app)
if (process.env.NODE_ENV === 'local') {
  connectFunctionsEmulator(functions, 'localhost', 5001)
}

// ---------- Firestore ----------
const firestore = getFirestore(app)
if (process.env.NODE_ENV === 'local') {
  connectFirestoreEmulator(firestore, 'localhost', 5055)
}

await initAppCheck()

const webFirestore = {
  doc: doc,
  collection: collection,
  collectionGroup: collectionGroup,
  getDoc: getDoc,
  getDocs: getDocs,
  query: query,
  where: where,
  orderBy: orderBy,
  limit: limit,
  addDoc: addDoc,
  setDoc: setDoc,
  updateDoc: updateDoc,
  deleteDoc: deleteDoc,
  onSnapshot: onSnapshot,
  runTransaction: firestoreRunTransaction,
  writeBatch: writeBatch,
  increment: increment,
  deleteField: deleteField,
  arrayUnion: arrayUnion,
  arrayRemove: arrayRemove,
  startAt: startAt,
  startAfter: startAfter,
  endAt: endAt,
  endBefore: endBefore,
  serverTimestamp: serverTimestamp
}

export { firebase, storage, auth, api, functions, firestore, webFirestore }
